<template>
  <el-menu class="navbar" mode="horizontal">
    <!--展开关闭菜单-->
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <!--历史路由界面-->
    <history-vue-list class="historyVueList"></history-vue-list>
    <!--头像-->
    <div class="right-container">
      <div class="react-right react-l-s">
        <span class="text" style="font-size: 15px">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
        <el-image class="notice-icon-2" :src="require('@/assets/icons/notice-icon-2.png')" fit="fit"
          style="margin-left: 10px" />
        <el-button type="primary" size="medium" class="operator-btn" style="margin-left: 10px" @click="clickOpenBuy"><img
            style="width: 14px; height: 14px; margin-bottom: -2px" src="@/assets/icons/vip.png" alt="" />
          VIP</el-button>
      </div>

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <svg-icon class="user-avatar" :icon-class="avatarIcon"></svg-icon>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item> 首页 </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <template v-if="visibleDlgBuy">
        <el-dialog title="购买" :visible.sync="visibleDlgBuy" width="600px">
          <div class="buy">
            <div class="buy-item">
              <div class="buy-item-label">功能：</div>
              <el-select v-model="value" placeholder="请选择" @change="clickChange">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- <div class="buy-item">
              <div class="buy-item-label">功能：</div>
              <div class="buy-item-txt">跟进安排</div>
            </div> -->
            <div class="buy-item">
              <div class="buy-item-label">价格：</div>
              <div class="buy-item-txt">{{ price }}元/月</div>
            </div>
            <div class="buy-item">
              <div class="buy-item-label">时长：</div>
              <div class="buy-item-txt">
                <el-input-number v-model="num" :min="1" :precision="0"></el-input-number>
                <span>月</span>
              </div>
            </div>
            <div class="buy-item">
              <div class="buy-item-label">价格合计：</div>
              <div class="buy-item-txt buy-item-red">{{ priceZJ }}元/月</div>
            </div>
            <div class="buy-item">
              <div class="buy-item-label">购买说明：</div>
              <div class="buy-item-txt">可按月购买。最低起购为1个月</div>
            </div>
            <div class="buy-item">
              <div class="buy-item-label">功能详情：</div>
              <div class="buy-item-txt">该功能可对员工工作进行安排</div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="visibleDlgBuy = false">取 消</el-button>
              <el-button type="primary" @click="clickGM" class="operator-btn">确 定</el-button>
            </span>
          </div>
        </el-dialog>
      </template>

      <template v-if="visibleDlgOrder">
        <el-dialog title="订单确认" :visible.sync="visibleDlgOrder" width="600px" :before-close="handleClose">
          <div class="buy">
            <div class="buy-item">
              <div class="buy-item-label">功能：</div>
              <div class="buy-item-txt">跟进安排</div>
            </div>
            <div class="buy-item">
              <div class="buy-item-label">购买数量：</div>
              <div class="buy-item-txt">{{ num }}个月</div>
            </div>
            <div class="buy-item">
              <div class="buy-item-label">功能详情：</div>
              <div class="buy-item-txt">该功能可对员工工作进行安排</div>
            </div>
            <div class="buy-item">
              <div class="buy-item-label">支付金额：</div>
              <div class="buy-item-txt buy-item-red">{{ priceZJ }}元</div>
            </div>
            <el-divider></el-divider>
            <div class="buy-item">
              <div class="buy-item-label">支付方式：</div>
            </div>
            <div class="buy-item buy-group">
              <el-radio-group v-model="radio">
                <el-radio :label="3">微信支付</el-radio>
                <el-radio :label="6" disabled>支付宝支付</el-radio>
                <el-radio :label="9" disabled>对公付款</el-radio>
              </el-radio-group>
            </div>
            <img style="width: 180px;height: 180px;" :src="qrCodeImgUrl">
            <!-- <div class="buy-item buy-footer">
              <el-divider></el-divider>
              <div class="buy-footer-dv">
                <p>支付金额：<span>15</span>元</p>
                <el-button class="operator-btn" type="primary" @click="
                  visibleDlgOrder = false;
                visibleDlgSuc = true;
                " style="padding-top: 0px; padding-bottom: 0px">确认付款</el-button>
              </div>
            </div> -->
          </div>
        </el-dialog>
      </template>

      <template v-if="visibleDlgSuc">
        <el-dialog :visible.sync="visibleDlgSuc" width="300px">
          <i class="el-icon-success" style="font-size: 100px; color: #67c23a"></i>
          <p>支付成功</p>
        </el-dialog>
      </template>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatDate } from "@/utils/date";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import HistoryVueList from "@/components/HistoryVueList";
import { storeWxPay, getPayStatu } from '../../../api/ActivitySetting';
import QRCode from 'qrcode' // 引入生成二维码插件qrcode
import globaldata from "@/utils/globaldata";
export default {
  components: {
    Breadcrumb,
    Hamburger,
    HistoryVueList,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
    priceZJ() {
      return this.num * this.price
    }

  },
  data() {
    return {
      avatarIcon: "user-2",
      timing: null,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      visibleDlgBuy: false,
      num: 1,
      visibleDlgOrder: false,
      radio: 3,
      visibleDlgSuc: false,
      options: [{
        value: '1',
        label: 'VIP'
      }, {
        value: '2',
        label: 'SVIP'
      }],
      value: '1',
      price: 0,
      // priceZJ: 10,
      qrCodeImgUrl: '',
      timer: null
    };
  },
  mounted() {
    this.price = globaldata.getAdminStore().vipPrice
    console.log(globaldata.getAdminStore(), 'globaldata.getAdminStore()')
    this.timeFn();
    // this.clickZJ()
  },
  beforeDestroy() {
    clearInterval(this.timing);
  },
  methods: {
    ...mapActions(['GetInfo']),
    handleClose() {
      clearInterval(this.timer);
      this.visibleDlgOrder = false
    },
    clickChange(v) {
      if (v == 1) {
        this.price = globaldata.getAdminStore().vipPrice
      } else if (v == 2) {
        this.price = globaldata.getAdminStore().svipPrice
      }
      // this.clickZJ()
    },
    clickOpenBuy() {
      this.num = 1;
      this.visibleDlgBuy = true;
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    clickGM() {
      storeWxPay({
        payWay: 1, // 支付方式1 微信 2支付宝 3对公
        price: this.priceZJ, // 总价
        month: this.num, // 数量
        isVip: this.value, //0：非VIP,1：VIP,2：SVIP
        storeFrontId: globaldata.getAdminStore().storeFrontId // 门店id
      }).then((res) => {
        let img = QRCode.toDataURL(res.data.order.codeUrl)
        img.then(t => {
          this.qrCodeImgUrl = t
          console.log(this.qrCodeImgUrl, t, '============')
          this.fdsa(res.data.orderSn)
        })

      })
      this.visibleDlgBuy = false
      this.visibleDlgOrder = true
    },
    fdsa(v) {
      this.timer = setInterval(() => {
        getPayStatu({
          orderId: v
        }).then((res) => {
          if (res.data.code == 1000) {
            this.visibleDlgOrder = false
            this.visibleDlgSuc = true
            this.GetInfo()
            location.reload()
            clearInterval(this.timer)
          }
        })
      }, 1000)
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatDate(new Date(), "hh: mm: ss");
        this.dateYear = formatDate(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 52px;
  line-height: 52px;
  border-radius: 0px !important;
  background: #ecf5fc;
}

.screenfull {
  position: absolute;
  right: 90px;
  top: 6px;
  color: red;
}

.user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}

.avatar-wrapper {
  cursor: pointer;
  margin-top: 5px;
  position: relative;
}

.avatar-container {
  top: 0px;
  height: 50px;
  display: inline-block;
  position: absolute;
  right: 35px;
}

.hamburger-container {
  line-height: 58px;
  height: 50px;
  float: left;
  padding: 0 10px;
}

.el-icon-caret-bottom {
  position: absolute;
  right: -20px;
  top: 25px;
  font-size: 12px;
}

.historyVueList {
  margin-left: 50px;
}

.right-container {
  height: 50px;
  width: 420px;
  position: absolute;
  right: 0px;
  top: 0;
}

.react-right {
  width: 320px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  margin-right: 20px;

  .text {
    display: inline-block;
  }
}

.notice-icon-2 {
  width: 42px;
  height: 42px;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

.buy {
  &-item {
    display: flex;

    &-label {
      text-align: right;
      width: 120px;
      margin-right: 10px;
    }

    &-red {
      color: #f00;
    }

    &-text {
      width: calc(100% - 120px - 10px);
    }
  }

  &-group {
    box-sizing: border-box;
    padding-left: 50px;
  }

  &-footer {
    margin-top: 100px;
    display: block;

    &-dv {
      display: flex;
      justify-content: right;

      p {
        margin-right: 15px;

        span {
          color: #f00;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue